
export default {
	data: function () {
		return {
			randomNumber: null,
			hasScroll: true,
			hasScrolled: false,
			activeIndex: 0,
		}
	},
	props: [
		"color",
		"items",
		"texts",
		"type"
	],
	created() {
		// this.playSlideshow();
	},
	watch: {
	},
	methods: {
		scrollMove(el, index) {
			// Identify Element based on template
			const gallery = this.$el.firstChild;
			let slide = null;

			if (gallery) {
				slide = gallery.children[index];
				// Define Scroll Value and Scroll
				const scrollValue = slide.offsetLeft + slide.offsetWidth - gallery.offsetWidth + 20;
				gallery.scroll({ top: 0, left: scrollValue, behavior: "smooth" });
			}
		},
		evalScroll(el) {
			const gallery = el.srcElement;
			// Has Scrolled
			gallery.scrollLeft > 0 ? (this.hasScrolled = true) : (this.hasScrolled = false);
			// Remaining Scroll
			gallery.scrollWidth - (gallery.scrollLeft + gallery.offsetWidth) === 0
				? (this.hasScroll = false)
				: (this.hasScroll = true);

			// Spacer for Large devices
			const galleryWidth = gallery.offsetWidth;
			const scrollValue = this.hasScrolled
				? gallery.scrollLeft + galleryWidth - 20
				: gallery.scrollLeft + galleryWidth / 3;

			// Sets active Index Depending On scroll position.
			for (let index = 0; index < gallery.children.length; index++) {
				const slide = gallery.children[index];
				if (
					scrollValue > slide.offsetLeft + slide.offsetWidth / 2 &&
					scrollValue < slide.offsetLeft + slide.offsetWidth + slide.offsetWidth / 2
				) {
					this.activeIndex = index;
				}
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/blocks/slideshow-block/slideshow.block.js